<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center signup-outer-container"
  >
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 p-0">
      <div class="d-flex justify-content-center">
        <div class="mt-3">
          <img
            src="/favicon/c3-logo.png"
            class="rounded"
            alt="Community Care Connection"
          />
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-5 my-5 p-0">
      <div class="card shadow-card p-5">
        <h1 class="display-4 text-center mb-3">Register Now</h1>
        <p class="text-muted text-center mb-5">Community Care Connection</p>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            v-model="client.first"
            autocomplete="false"
            placeholder="First Name"
          />
        </div>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            v-model="client.last"
            autocomplete="false"
            placeholder="Last Name"
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            class="form-control"
            v-model="client.email"
            autocomplete="false"
            placeholder="Email"
          />
        </div>
        <div class="form-group">
          <input
            name="mobilePhone"
            type="text"
            class="form-control"
            v-model="client.phone"
            v-cleave="cleave.phone"
            autocomplete="false"
            placeholder="Mobile Phone"
          />
        </div>
        <div class="form-group">
          <div class="input-group input-group-merge">
            <input
              :type="fieldType"
              class="form-control form-control-appended"
              v-model="client.password"
              placeholder="Password"
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fe" :class="eyeClass" @click="togglePassword"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="input-group input-group-merge">
            <input
              :type="fieldType"
              class="form-control form-control-appended"
              v-model="client.password_confirmation"
              placeholder="Confirm Password"
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fe" :class="eyeClass" @click="togglePassword"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <select
            id="occupation"
            :disabled="loading"
            v-model="client.occupation"
            class="form-control"
            placeholder="Occupation"
          >
            <option value selected>Select An Occupation</option>
            <option :value="o.id" v-for="o in occupations.data" :key="o.id">
              {{ o.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Would you like to become a listed C3 Vendor?</label>
          <div class="d-flex">
            <div class="custom-control custom-switch ml-3">
              <input
                type="checkbox"
                class="custom-control-input"
                id="isVendor"
                v-model="isVendor"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="isVendor"
                >{{ isVendor ? "Yes" : "No" }}</label
              >
            </div>
          </div>
        </div>
        <div :class="`accordion ${isVendor ? 'opened' : 'closed'}`">
          <div class="form-group">
            <label>Vendor Name</label>
            <input type="text" v-model="vendor.name" class="form-control" />
          </div>
          <div class="form-group">
            <label>Vendor Email</label>
            <input type="email" v-model="vendor.email" class="form-control" />
          </div>
          <div class="form-group">
            <label>Vendor Website</label>
            <input type="text" v-model="vendor.site" class="form-control" />
          </div>
          <div class="form-group">
            <label>Vendor Phone</label>
            <input
              type="text"
              v-model="vendor.phone"
              class="form-control"
              v-cleave="cleave.phone2"
            />
          </div>
        </div>
        <div class="form-group">
          <label
            >How would you like to recieve 2 factor auth notifications?</label
          >
          <div class="d-flex mb-5">
            <div class="custom-control custom-switch ml-3 mr-5">
              <input
                type="checkbox"
                class="custom-control-input"
                id="sendingSMS"
                v-model="client.enable_sending_sms"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="sendingSMS"
                >SMS</label
              >
            </div>
            <div class="custom-control custom-switch ml-5">
              <input
                type="checkbox"
                class="custom-control-input"
                id="sendingEmail"
                v-model="client.enable_sending_email"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="sendingEmail"
                >Email</label
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="d-flex mb-5">
            <div class="custom-control custom-switch ml-3 mr-5">
              <input
                type="checkbox"
                class="custom-control-input"
                id="privacyAccepting"
                v-model="privacyAccepted"
              />
              <label
                class="custom-control-label cursor-pointer"
                for="privacyAccepting"
                >I Agree to
                <span class="btn btn-link p-0" @click="showPrivacyModal"
                  >Privacy Policy</span
                >.</label
              >
            </div>
          </div>
        </div>
        <div class="form-group">
          <button
            class="btn btn-primary btn-block"
            @click="doRegistration"
            :disabled="!privacyAccepted"
          >
            <span v-if="!saving">Register</span>
            <span
              class="spinner-border spinner-border-sm"
              v-if="saving"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div class="text-center">
          <small class="text-muted text-center">
            Already have an account?
            <router-link to="/login">Log in</router-link>.
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Register",
  computed: {
    ...mapState(["occupations", "loading", "saving"]),
    eyeClass: function () {
      return this.showPassword ? "fe-eye-off" : "fe-eye";
    },
    fieldType: function () {
      return this.showPassword ? "text" : "password";
    },
  },
  data() {
    return {
      errors: [],
      isVendor: false,
      privacyAccepted: false,
      client: {
        first: "",
        last: "",
        email: "",
        phone: "",
        occupation: "",
        password_confirmation: "",
        password: "",
        enable_sending_sms: false,
        enable_sending_email: false,
        is_vendor: false,
      },
      vendor: {
        name: "",
        email: "",
        phone: "",
        site: "",
      },
      showPassword: false,
      cleave: {
        phone: { blocks: [3, 3, 4], delimiter: "-", numericOnly: true },
        phone2: { blocks: [3, 3, 8], delimiter: "-", numericOnly: true },
      },
    };
  },
  mounted() {
    this.$store.dispatch("occupations/all");
    this.client.email = this.$route.query.email || "";
  },
  methods: {
    togglePassword: function () {
      this.showPassword = this.showPassword ? false : true;
    },
    doRegistration: function () {
      this.errors = [];
      if (this.client.first == "") {
        this.errors.push("First Name is required");
      }

      if (this.client.last == "") {
        this.errors.push("Last Name is required");
      }

      if (this.client.email == "") {
        this.errors.push("Email is required");
      }

      if (this.client.phone == "") {
        this.errors.push("Phone is required");
      }
      if (this.client.phone !== "" && this.client.phone.length < 12) {
        this.errors.push("The phone must be at least 10 digits.");
      }

      if (this.client.password != "") {
        if (this.client.password !== this.client.password_confirmation) {
          this.errors.push("Passwords do not match");
        } else if (this.client.password.length < 8) {
          this.errors.push("The password must be at least 8 characters.");
        }
      } else {
        this.errors.push("Password is required");
      }

      if (this.isVendor) {
        if (this.vendor.name == "") {
          this.errors.push("Vendor Name is required");
        }
        if (this.vendor.email == "") {
          this.errors.push("Vendor Email is required");
        }
        if (this.vendor.site == "") {
          this.errors.push("Vendor Website is required");
        }
        if (this.vendor.phone == "") {
          this.errors.push("Vendor Phone is required");
        }
      }

      if (this.errors.length <= 0) {
        if (this.isVendor) {
          this.client.vendor = this.vendor;
          this.client.is_vendor = this.isVendor;
        }
        this.$store.dispatch("users/register", this.client);
      } else {
        let msg = this.errors.join("<br>");
        this.$store.dispatch(
          "setError",
          { message: msg, title: "Validation Errors" },
          { root: true }
        );
        this.errors = [];
      }
    },
    showPrivacyModal: function (event) {
      event.preventDefault();
      event.stopPropagation();
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-4",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          type: "info",
          title: "Terms & Conditions",
          html: `<div class="justify-text">By clicking the "I Accept" button displayed as part of the software loading process, you agree to the following terms and conditions (The "agreement") covering your use of the services and the C3 website whether in connection with a paid or trial period subscription. If you are entering into this agreement on behalf of a company or other legal entity, you represent that you have the authority to bind such entity to these terms and conditions, in which case the terms "you" or "your" shall refer to such entity. If you do not have such authority, or if you do not agree with these terms and conditions, you must select the "I Decline" button and may not use the service.</div>`,
          confirmButtonText: "I Accept",
          cancelButtonText: "I Decline",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
        .then((result) => {
          if (result.value) {
            this.privacyAccepted = true;
          } else {
            this.privacyAccepted = false;
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
@media (max-width: 1024px) {
  .signup-outer-container {
    margin-top: -84px;
  }
}
.accordion {
  transition: all 0.7s;
  overflow: hidden;

  &.closed {
    max-height: 0;
  }
  &.opened {
    max-height: 900px;
  }
}
</style>
